export default "__VITE_ASSET__c6927886__"